// @docs https://[domain]/api/v1/docs
export default {
  List: "/organizations",
  ListShort: "/organizations/short",
  Detail: "/organizations",
  Update: "/organizations",
  Create: "/organizations",
};
